<template>
    <div class="settings-layout details-layout">
      <form>
          <div class="form-section">
              <div class="registration-page-title">Billing info</div>
          </div>
          <div class="">
              <div class="form-section">

                  <div class="form-group w-80">
                      <label>BILLING EMAIL</label>
                      <div class="input-group-cover">
                          <input type="text" name="billingEmail" id="billingEmail" placeholder="E-mail Address" class="form-control required custom-msg-display" v-model="form.email" @blur="v$.form.email.$touch()">
                      </div>
                          <FormError :validationStatus="v$.form.email"/>
                  </div>
                      
                  <div class="form-group w-80">
                      <label>BILLING PHONE</label>
                      <div class="input-group-cover">
                          <div class="two-fields">
                              <div class="input-group-cover">
                                  <input type="text" placeholder="" name="phone_code" id="phone_code" class="form-control custom-msg-display" v-model="form.area_phone" disabled>
                              </div>
                              <div class="input-group-cover" style="margin-left: 2%;">
                                  <input type="text" name="phone" id="phone" class="form-control custom-msg-display digits" v-model="form.phone" @blur="v$.form.phone.$touch()">
                                  <FormError :validationStatus="v$.form.phone"/>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="w-flex-80">
                      <div class="form-group">
                          <label>CONTACT NAME</label>
                          <div class="input-group-cover">
                              <input type="text" placeholder="First Name" name="first_name" id="first_name" v-model="form.firstName" @blur="v$.form.firstName.$touch()">
                          </div>
                          <FormError :validationStatus="v$.form.firstName"/>
                      </div>

                      <div class="form-group" style="margin-left: 15px;">
                          <label style="color: #FFFFFF !important;">-</label>
                          <div class="input-group-cover">
                              <input type="text" placeholder="Last Name" name="last_name" id="last_name"  v-model="form.lastName" @blur="v$.form.lastName.$touch()">
                          </div>
                          <FormError :validationStatus="v$.form.lastName"/>
                      </div>
                  </div>    

                  <div v-if="countryCode == 'AU'" class="form-group w-80">
                      <label>ABN / EIN / NIB </label>
                      <div class="input-group-cover">
                          <input type="text" name="abn" id="abn" @input="submit" placeholder="Business registration number" v-model="form.abn" @blur.once="v$.form.abn.$touch()">
                      </div>
                  </div>

                  <AutoCompleteLocation
                      addressType="Billing" 
                      @update="searchAddress" 
                      :formData="formData"
                      :countryCode="countryCode"
                  />
              </div> 
          </div>  
       </form>
   </div>
</template>

<script>
import AutoCompleteLocation from './../../AutoCompleteLocation.vue';
import FormError from './../../FormError.vue';
import { required, requiredIf, email, numeric, helpers, minLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import axios from "axios";
const { withAsync } = helpers

const validABN = async (value) => {
  if (value === "") return true;

  if(value.length == 11){
      const data = {'abn': value};
      const response =  await axios.post('check-abn', data)
      .catch(function (error) {
          console.log(error);
          return false;
      })
      
      return (response.data.status === 'true');
  }
}

const only9Digits = (value) => {
  if (value === '') return true

  return value.trim().length === 9;
}

const only11Digits = (value) => {
  if (value === '') return true

  return value.trim().length === 11;
}

export default {
  inject: ['submitForm'],
  setup(){
      return { v$: useVuelidate() }
  },
  name: "BillingInfo",
  props: ['url', 'merchant', 'formData', 'countryCode', ],
  components: {AutoCompleteLocation, FormError},
  data(){
      return{
          form:{
              firstName: this.formData.firstName,
              lastName: this.formData.lastName,
              country: this.formData.country,
              address1: this.formData.address1,
              zip: this.formData.zip,
              email: this.merchant ? this.merchant.email : this.formData.email,
              suburb: this.formData.suburb,
              state: this.formData.state,
              area_phone: this.merchant ? "+" + this.merchant.user_info.mobile_country_code :this.formData.mobile.substring(0, this.formData.mobile.indexOf(' ')),//"+" + this.merchant.user_info.mobile_country_code,
              phone: this.merchant ? this.merchant.user_info.mobile_number : (this.formData.mobile.substring(this.formData.mobile.indexOf(' '))).replaceAll(' ', ''),
              abn: this.formData.abn,
          }
      }
  },
  methods:{
      searchAddress(addressObject){
          Object.assign(this.form, addressObject.data);
          this.v$.form.address1.$touch();
      },
      submit(){
          this.$emit('update', {
              data:{
                  billingFirstName: this.form.firstName,
                  billingLastName: this.form.lastName,
                  billingCountry: this.form.country,
                  billingAddress1: this.form.address1,
                  billingZip: this.form.zip,
                  billingSuburb: this.form.suburb,
                  billingState: this.form.state,
                  billingEmail: this.form.email,
                  billingAreaPhone: this.form.phone,
                  billingPhone: this.form.phone,
                  abn: this.form.abn,
                  ein: this.form.ein
              },
              valid: !this.v$.$invalid
          })
      },
      valid(){
          this.v$.form.address1.$touch();
          return !this.v$.$invalid;
      }
  },
  updated(){
      if(!this.v$.$invalid){
          this.submit();
      }
  },
  validations:{
      form:{
          firstName: {required, minLength: minLength(2)},
          lastName: {required, minLength: minLength(2)},
          country: {required},
          address1: {required},
          zip: {required},
          suburb: {required},
          state: {required},
          email: {required},
          phone: {required, numeric}
      }
  }
}
</script>